import withScroll from '../hoc/withScroll'

export default withScroll({
  name: 'sticky-contact',

  ui: {
    toggle: '[js-sticky-contact-toggle]',
    panel: '[js-sticky-contact-list]',
    text: '[js-sticky-contact-text]',
  },

  events: [
    {
      on: 'click',
      target: 'toggle',
      handle () {
        this.el.classList.toggle('is-open')
      },
    },
  ],

  componentDidMount () {
    setTimeout(() => {
      this.el.style.setProperty('--widthStickyOpen', `${260 + this.ui.text.offsetWidth}px`)
    }, 500)
  },

  onScroll ({ y }) {
    if (window.innerWidth >= 768) {
      this.el.classList.remove('is-init-open')

      if (y > 200) {
        this.el.classList.remove('is-open')
      } else {
        this.el.classList.add('is-open')
      }
    }
  },
})
